module.exports = "/_next/static/images/socket-f70188ac3eaa0e46faae3c57d2848fa7.png";